<form [formGroup]="form">
	<h2 mat-dialog-title>Credit Card</h2>
	<mat-dialog-content>
		<div fxLayout="column">
			<mat-form-field>
				<mat-label>{{'placeOrderView.cardNumberLabel' | translate}}</mat-label>
				<input appOnlyNumber="true" formControlName="number" matInput type="text"/>
				<mat-error>
					{{'placeOrderView.cardNumberLabel' | translate}} is required
				</mat-error>
			</mat-form-field>
			<div fxLayout="row wrap" fxLayoutAlign="space-between" fxLayoutGap="15px">
				<mat-form-field fxFlex fxFlex.gt-xs="30">
					<mat-label>{{'placeOrderView.expMonthText' | translate}}</mat-label>
					<mat-select formControlName="expMonth">
						<mat-option [value]="undefined" disabled>
							{{'placeOrderView.expDateOptionUnselected' | translate}}
						</mat-option>
						<mat-option value="JAN">
							{{'placeOrderView.expDateOptionJanuary' | translate}}
						</mat-option>
						<mat-option value="FEB">
							{{'placeOrderView.expDateOptionFebruary' | translate}}
						</mat-option>
						<mat-option value="MAR">
							{{'placeOrderView.expDateOptionMarch' | translate}}
						</mat-option>
						<mat-option value="APR">
							{{'placeOrderView.expDateOptionApril' | translate}}
						</mat-option>
						<mat-option value="MAY">
							{{'placeOrderView.expDateOptionMay' | translate}}
						</mat-option>
						<mat-option value="JUN">
							{{'placeOrderView.expDateOptionJune' | translate}}
						</mat-option>
						<mat-option value="JUL">
							{{'placeOrderView.expDateOptionJuly' | translate}}
						</mat-option>
						<mat-option value="AUG">
							{{'placeOrderView.expDateOptionAugust' | translate}}
						</mat-option>
						<mat-option value="SEP">
							{{'placeOrderView.expDateOptionSeptember' | translate}}
						</mat-option>
						<mat-option value="OCT">
							{{'placeOrderView.expDateOptionOctober' | translate}}
						</mat-option>
						<mat-option value="NOV">
							{{'placeOrderView.expDateOptionNovember' | translate}}
						</mat-option>
						<mat-option value="DEC">
							{{'placeOrderView.expDateOptionDecember' | translate}}
						</mat-option>
					</mat-select>
				</mat-form-field>
				<mat-form-field fxFlex fxFlex.gt-xs="30">
					<mat-label>{{'placeOrderView.expYearText' | translate}}</mat-label>
					<mat-select formControlName="expYear">
						<mat-option [value]="undefined" disabled>
							{{'placeOrderView.expDateOptionYearUnselected' | translate}}
						</mat-option>
						<mat-option *ngFor="let year of expirationYears" [value]="year">
							{{year}}
						</mat-option>
					</mat-select>
				</mat-form-field>
				<mat-form-field fxFlex fxFlex.gt-xs="30">
					<mat-label>
						{{'placeOrderView.securityCodeLabel' | translate}}
					</mat-label>
					<input appOnlyNumber="true" formControlName="securityCode" matInput type="text"/>
					<mat-error>
						{{'placeOrderView.securityCodeLabel' | translate}} is required
					</mat-error>
				</mat-form-field>
			</div>
			<mat-form-field>
				<mat-label>{{'placeOrderView.cardHolderNameLabel' | translate}}</mat-label>
				<input formControlName="name" matInput type="text"/>
				<mat-error>
					{{'placeOrderView.cardHolderNameLabel' | translate}} is required
				</mat-error>
			</mat-form-field>
			<mat-form-field>
				<mat-label>{{'placeOrderView.streetAddressLabel' | translate}}</mat-label>
				<input formControlName="address" matInput type="text"/>
				<mat-error>
					{{'placeOrderView.streetAddressLabel' | translate}} is required
				</mat-error>
			</mat-form-field>
			<mat-form-field>
				<mat-label>{{'placeOrderView.postalCodeLabel' | translate}}</mat-label>
				<input formControlName="zip" matInput type="text"/>
				<mat-error>{{'placeOrderView.postalCodeLabel' | translate}}
					is required
				</mat-error>
			</mat-form-field>
			<app-email-input-with-chips
				[parentForm]="form"
				[label]="'Email Receipt'"
				[placeholder]="'Add email addresses'"
				[isTextMessagingEnabled]="false">
			</app-email-input-with-chips>
		</div>
	</mat-dialog-content>
	<mat-dialog-actions fxLayout="row" fxLayoutAlign="end" fxLayoutGap="5px">
		<button color="accent" mat-dialog-close mat-raised-button>Cancel</button>
		<button [disabled]="form?.pristine || form?.invalid" [mat-dialog-close]="form?.getRawValue()" color="primary"
				mat-raised-button>
			Pay
		</button>
	</mat-dialog-actions>
</form>
